import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const flowStepImporterSelectors = importerSelectors(
  'flowStep.importer',
);

export default flowStepImporterSelectors;
